
import * as React from 'react';
import { FieldProps, FormValue, RadioGroup, Radio, } from 'informed';
import { FormGroup } from 'reactstrap';
import { createFieldProps, validateRadioGroup } from '../form.utils';
import { RadioModel, RadioOptionsModel } from './radio.model';
import { FormFieldProps } from '../InputField';
import { FormErrorField } from '../FormError';
import { LabelCustom as Label } from '../..';

export const RadioField = (props: FormFieldProps<RadioModel>) => {
  const {
    fieldId, 
    field, 
    error, 
    touched, 
  } = props;
  // TODO Replace any
  const fieldProps: FieldProps<any, any> & React.InputHTMLAttributes<HTMLInputElement> = createFieldProps(field, error, touched, fieldId);

  return field.options && (
    <FormGroup key={fieldId} className="position-relative register-radios">
      {error && touched && field.errorMessage && (
        <FormErrorField errorMessage={field.errorMessage || error[field.name]} tooltip={fieldId} />
      )}
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="row">
            <div className="col-3 col-sm-3">
            <Label for={fieldId} mandatory={field.required} >
              {field.label}
            </Label>
            </div>
            <div className="col-9 col-sm-9">
              <RadioGroup 
                field={fieldProps.field}
                validate={(value: FormValue) => validateRadioGroup(value, field)}
              >
                <div className="row">
                  {field.options.map((radio: RadioOptionsModel, radioIndex) => {
                    const radioKey = `${fieldId}_${field.name}_${radioIndex}`;
                    radio.value = radio.value && radio.value.toString();
                    return (
                      <div key={radioKey} className="col-4 col-sm-3">
                        <div className="form-radio">
                          <Label className="form-check-label">
                            {radio.label}                         
                            <Radio
                              className="form-check-input" 
                              value={radio.value as string | number} 
                              name={field.name}
                            />
                            <span className="checkmark" />
                          </Label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </RadioGroup>
            </div>
          </div>
        </div>
      </div>
    </FormGroup>
  );
};